import { useEffect } from 'react';
import { Outlet } from 'react-router-dom';
import { useAppDispatch } from '../store/hooks';
import { checkMe } from '../store/slice/loginSlice';
import { getStoreLocal } from '../utils/localStore';
import Login from '../components/login';
const AuthenticatedRoute = () => {
    // const { user } = useAppSelector((state) => state.login);
    const dispatch = useAppDispatch();

    useEffect(() => {
        // if (user?.keycloakId) return;
        dispatch(
            checkMe({
                type: 1,
                redirectUri: process.env.REACT_APP_HOST_NAME_REDIRECT,
            }),
        );
    }, [dispatch]);

    if (getStoreLocal('account_web')) {
        const user = JSON.parse(getStoreLocal('account_web'));
        if (!user?.keycloakId) return <Login />;
    }
    return <Outlet />;
};

export default AuthenticatedRoute;
